<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">职位Leader</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF " @click="delWorker">删除</p>-->
    </header>
    <div class="personalMain" >
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">姓名</p>
        <p > <input class="inforNameInput" type="text" v-model="data.nickName"  placeholder="请填写"></p>
      </div>
      <div class="inforName" >
        <p class="inforNameTop">职位</p>
        <p v-if="data"><input class="inforNameInput" type="text" placeholder="请填写" v-model="data.positions" ></p>
      </div>



      <div class="inforName">
        <p class="inforNameTop">讲讲你对候选人的吸引力</p>
        <p v-if="data">
          <textarea style="width: 100%;height: 5rem" v-model="data.leader_advantage" placeholder="请填写">{{data.leader_advantage}} </textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">你的管理风格</p>
        <p ><input class="inforNameInput" type="text" placeholder="请填写" v-model="data.leader_style" >
          </p>
      </div>
      <div class="button">
        <van-button class="button" style="width: 100%;margin: 0 auto" type="primary" @click="sveLeaderPositioner()">保存</van-button>

      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        data:{
          name:'',
          position:'',
          leader_advantage: "",
          leader_style: "",
          photo: ""

        }
      }
    },
    mounted(){
      this.getLeaderPositioner()
    },
    methods:{
      backHistory(){
//        this.$router.push("/comDetailsPosition")
        this.$router.push({
          path:"/comDetailsPosition",
          query:{id:this.$route.query.id}
        })
      },
      getLeaderPositioner(){
        this.$api.getLeaderPosition({'id':localStorage.getItem("userid")}).then(res=>{
          this.data=res.data?res.data[0]:{}
        }).catch(err=>{

        })
      },
      sveLeaderPositioner(){
        this.$api.sveLeaderPosition({
          "data[nickName]": this.data.nickName,
          "data[positions]": this.data.positions,
          "data[leader_advantage]": this.data.leader_advantage,
          "data[leader_style]": this.data.leader_style,
          'id':localStorage.getItem("userid")
        }).then(res=>{
          if(res.status==200){
            this.$router.push({
                path:"/comDetailsPosition",
              query:{id:this.$route.query.id}
            }
              )
            this.$toast("保存成功")
//            this.$router.push("/comDetailsPosition")

          }
//          this.$router.push("/editResume")
        }).catch(err=>{
        })
      },
      delWorker(){
        this.$api.delWork({'id':this.$route.params.id}).then(res=>{
          this.$router.push("/editResume")
        }).catch(err=>{
        })
      }
    },


  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 0 18px;
    margin-top: 90px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  .button{
    position: fixed;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/positionLeader.vue